import PropTypes from 'prop-types';
// material-ui
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

// project import
import Avatar from 'components/@extended/Avatar';
import { PopupTransition } from 'components/@extended/Transitions';

// assets
import CloseOutlined from '@ant-design/icons/CloseOutlined';

// ==============================|| SALE BILL - CANCEL ||============================== //

export default function AlertSaleBillCancel({ invoiceNumber, open, handleClose, onConfirm }) {
  return (
    <Dialog
      open={open}
      onClose={handleClose}
      keepMounted
      TransitionComponent={PopupTransition}
      maxWidth="xs"
      aria-labelledby="sale-bill-cancel-title"
      aria-describedby="sale-bill-cancel-description"
    >
      <DialogContent sx={{ mt: 2, my: 1 }}>
        <Stack alignItems="center" spacing={3.5}>
          <Avatar color="error" sx={{ width: 72, height: 72, fontSize: '1.75rem' }}>
            <CloseOutlined />
          </Avatar>
          <Stack spacing={2}>
            <Typography variant="h4" align="center">
              Are you sure you want to cancel this sale bill?
            </Typography>
            <Typography align="center">
              By canceling
              <Typography variant="subtitle1" component="span">
                {' '}
                &quot;{invoiceNumber}&quot;{' '}
              </Typography>
              sale bill, this action cannot be undone.
            </Typography>
          </Stack>

          <Stack direction="row" spacing={2} sx={{ width: 1 }}>
            <Button fullWidth onClick={handleClose} color="secondary" variant="outlined">
              No
            </Button>
            <Button fullWidth color="error" variant="contained" onClick={onConfirm} autoFocus>
              Yes, Cancel
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  );
}

AlertSaleBillCancel.propTypes = {
  invoiceNumber: PropTypes.string,
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  onConfirm: PropTypes.func
};

